import { useCallback } from 'react'
import { createWorkItem } from '../application/create-work-item'
import type { CreateWorkItemInput } from '../domain/workflow'
import { workItems$ } from '../store'
import { workItems as workItemsPort, notify } from '../wiring'

const useCreateWorkItem = () => {
	const create = useCallback(async (input: CreateWorkItemInput) => {
		const created = await createWorkItem(workItemsPort, input, notify)
		if (created) {
			workItems$.set([...workItems$.get(), created])
		}
		return created
	}, [])

	return { create }
}

export { useCreateWorkItem }
